import {
  JIA_MENG_GOODS_MANAGE_PATH,
  SETMEAL_PATH,
  SINGLE_PRODUCT_PATH
} from '@constant'
import { RouterView } from '@merchant-backend/common-components'
import { isNewOpen, isStoreAccount } from '@util'
import { Modal, Spin } from 'hljd'
import { observer, Provider } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import CourseGuide from '../Common/CourseGuide'
import ButtonGroup from './ButtonGroup'
import CheckInputStore from './CheckInput/store'
import StepOne from './StepOne'
import StepThree from './StepThree'
import StepTwo from './StepTwo'
import Store from './store'
import styles from './style.module.less'
import { getText } from './utils'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.params.id)
  }

  componentDidMount = async () => {
    this.store.init()
    this.setAsyncRouteLeaveHook()
  }

  /**
   * 拦截路由变化
   */
  setAsyncRouteLeaveHook = () => {
    const { router, route } = this.props
    router.setRouteLeaveHook(route, nextLocation => {
      if (nextLocation.query.noCheck) {
        return true
      }

      const { checkIsValuesChange } = this.store
      const isValuesChange = checkIsValuesChange()

      if (isValuesChange) {
        this.routerWillLeave(nextLocation)
      }
      return !isValuesChange
    })
  }

  /**
   * 检测是否修改内容进行提示
   */
  routerWillLeave = nextLocation => {
    const { spinning, isSingle, handleSave } = this.store
    const { id, isDraft } = this.store

    const pathTo = () => {
      hashHistory.push({
        pathname: nextLocation.pathname,
        query: { noCheck: true }
      })
    }

    if (id && !isDraft) {
      // 编辑已发布的
      Modal.confirm({
        title: '切换页面发布内容将不会保存，您确定这样操作吗？',
        onOk: () => {
          pathTo()
        }
      })
    } else {
      // 加盟体验店不保存草稿
      if (isStoreAccount()) {
        pathTo()
        return
      }

      Modal.confirm({
        title: `是否将该${getText(isSingle)}保存为草稿?`,
        okText: '保存',
        cancelText: '不保存',
        onOk: async () => {
          await handleSave('draft', true)
          pathTo()
        },
        okButtonProps: {
          spinning
        },
        onCancel: () => {
          pathTo()
        }
      })
    }
  }

  componentWillUnmount() {
    CheckInputStore.reset() // 移除CheckInput的检测状态
  }

  navLink = () => {
    const { isSingle, property_id } = this.store
    const link = isSingle
      ? SINGLE_PRODUCT_PATH
      : isStoreAccount()
        ? `${JIA_MENG_GOODS_MANAGE_PATH}/${property_id}`
        : SETMEAL_PATH

    hashHistory.push(link)
  }

  viewStyle = {
    marginBottom: 24,
    marginTop: 12
    // minWidth: 1520
  }

  bodyStyle = {
    paddingBottom: 0
  }

  contentStyle = {
    marginTop: 0
  }

  titleStyle = {
    height: 48
  }

  render() {
    const { max_step, isSingle, spinning } = this.store

    const text = getText(isSingle)

    const header = [<a onClick={this.navLink}>{text}管理</a>, `${text}单品`]

    return (
      <Provider
        centerStore={this.store}
        stepOneStore={this.store.stepOneStore}
        stepTwoStore={this.store.stepTwoStore}
        stepThreeStore={this.store.stepThreeStore}
      >
        <div className={styles.wrapper}>
          <Spin size="large" tip="正在发布···" spinning={spinning}>
            <div className={styles.main}>
              <RouterView
                header={header}
                title={`${getText()}基本信息`}
                bodyStyle={this.bodyStyle}
                viewStyle={this.viewStyle}
                titleStyle={this.titleStyle}
              >
                <div className={`${styles.meal} antd-hlj-small`}>
                  <StepOne params={this.props.params} />
                </div>
              </RouterView>
              <RouterView
                title={`${getText()}详情信息`}
                bodyStyle={{
                  paddingBottom: 17
                }}
                viewStyle={this.viewStyle}
                contentStyle={this.contentStyle}
                titleStyle={this.titleStyle}
              >
                <StepTwo />
              </RouterView>
              {max_step === 3 && (
                <RouterView
                  title={`${getText()}推荐信息`}
                  viewStyle={this.viewStyle}
                  contentStyle={this.contentStyle}
                  titleStyle={this.titleStyle}
                >
                  <StepThree />
                </RouterView>
              )}
            </div>
            <div className={styles.footer}>
              <ButtonGroup />
            </div>
          </Spin>
          {isNewOpen() && <CourseGuide taskId="2" />}
        </div>
      </Provider>
    )
  }
}
